import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { Check, ChevronsUpDown } from 'lucide-react';

const label = (c) => `${c.name}${c.company ? ` (${c.company})` : ''}`;

export const ClientCombobox = ({ clients = [], value, onChange, placeholder = 'Seleccionar prospecto' }) => {
  const [open, setOpen] = useState(false);
  const selected = clients.find(c => c.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen} modal>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between font-normal" data-testid="proposal-client-select">
          <span className="truncate">{selected ? label(selected) : <span className="text-muted-foreground">{placeholder}</span>}</span>
          <ChevronsUpDown className="w-4 h-4 opacity-50 shrink-0" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width]" align="start">
        <Command filter={(itemValue, search) => (itemValue.split('|')[0].toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput placeholder="Escribe el nombre..." data-testid="proposal-client-search" />
          <CommandList className="max-h-64">
            <CommandEmpty>Sin coincidencias</CommandEmpty>
            <CommandGroup>
              {clients.map(c => (
                <CommandItem
                  key={c.id}
                  value={`${c.name}|${c.id}`}
                  onSelect={() => { onChange(c.id); setOpen(false); }}
                  data-testid={`proposal-client-option-${c.id}`}
                >
                  <Check className={`w-4 h-4 mr-2 ${c.id === value ? 'opacity-100' : 'opacity-0'}`} />
                  {label(c)}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
